<div class="modal-header">
    <h4 class="modal-title">Actualizar Proveedor</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="form">
        <div class="row d-flex align-items-center">

            <div class="mb-3 col-12 col-sm">
                <label for="nombre">Nombre</label>
                <input type="text" class="form-control" id="nombre" formControlName="nombre"
                    [ngClass]="{'is-invalid': form.controls['nombre'].errors && form.controls['nombre'].touched}">
                <div class="invalid-feedback">
                    Debe ingresar un valor en el campo.
                </div>
            </div>
            <div class="mb-3 col-12 col-sm">
                <label for="apellido">Apellido</label><label class="campo-opcional">(Opcional)</label>
                <input type="text" class="form-control" id="apellido" formControlName="apellido">
            </div>
        </div>


        <div class="row">
            <div class="mb-3 col-12 col-sm">
                <label for="email">Correo Electrónico</label>
                <input type="email" class="form-control" formControlName="email"
                    [ngClass]="{'is-invalid': form.controls['email'].errors && (form.controls['email'].dirty || form.controls['email'].touched)}">
                <div class="invalid-feedback" *ngIf=" form.controls['email'].errors?.['required']">
                    Ingrese un correo electrónico.
                </div>
                <div class="invalid-feedback" *ngIf=" form.controls['email'].errors?.['email']">
                    El correo electrónico no es válido.
                </div>
            </div>
            <div class="mb-3 col-12 col-sm">
                <label for="razon_social">Razón Social</label><label class="campo-opcional">(Opcional)</label>
                <input type="text" class="form-control" id="razon_social" formControlName="razon_social">
            </div>

        </div>
        <div class="row">
            <div class="mb-3 col-12 col-sm">
                <label for="fono">Teléfono</label><label class="campo-opcional">(Opcional)</label>
                <input type="text" class="form-control" id="fono" formControlName="fono">
            </div>
            <div class="mb-3 col-12 col-sm">
                <label for="precio_compra">Teléfono 2</label><label class="campo-opcional">(Opcional)</label>
                <input type="text" class="form-control" id="fono2" formControlName="fono2">
            </div>
        </div>
        <div class="row">
            <div class="mb-3 col-12 col-sm-12">
                <label for="direccion">Dirección</label><label class="campo-opcional">(Opcional)</label>
                <input type="text" class="form-control" id="direccion" formControlName="direccion">
            </div>
        </div>

    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="guardar()">Actualizar</button>
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Cancelar</button>
</div>